import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import Slide from "@material-ui/core/Slide";
import Grid from "@material-ui/core/Grid";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import InputAdornment from "@material-ui/core/InputAdornment";

import {
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	OutlinedInput,
} from "@material-ui/core";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";

import MomentUtils from "@date-io/moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import MembershipsList from "./MembershipsList";
import UpsellsList from "./UpsellsList";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function ElevationScroll(props) {
	const { children, target, onElevationChange } = props; // `target` is a ref to the scrollable element
	const [elevated, setElevated] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (target.current) {
				const isElevated = target.current.scrollTop > 70;
				setElevated(isElevated);
				onElevationChange(isElevated);
			}
		};

		const scrollableElement = target.current;
		scrollableElement.addEventListener("scroll", handleScroll);

		return () => {
			scrollableElement.removeEventListener("scroll", handleScroll);
		};
	}, [target, onElevationChange]);

	// Define custom elevation styles
	const elevationStyle = elevated
		? {
				boxShadow: "0 2px 4px 0 rgba(13,22,25,.058)",
				backgroundColor: "#FFF",
		  }
		: {
				boxShadow: "none",
		  };

	// Apply custom styles to the children component
	return React.cloneElement(children, {
		style: { ...children.props.style, ...elevationStyle },
	});
}

const ServiceAddUpsells = ({ open, onClose, ...props }) => {
	const classes = useStyles("BookingFunnel");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	const hasOptions = true;

	const dialogContentRef = React.useRef(null);

	const [isElevated, setIsElevated] = useState(false);

	const handleElevationChange = (elevated) => {
		setIsElevated(elevated);
	};

	const serviceOptions = [
		{
			upsellOption: "Snow board training",
			detail: "30 mins",
			price: "$40",
		},
		{
			upsellOption: "Guitar sheet music",
			detail: "Books",
			price: "$25",
		},
		{
			upsellOption: "BMI test",
			detail: "30 mins",
			price: "$40",
		},
		{
			upsellOption: "Guitar sheet music 2",
			detail: "Books",
			price: "$25",
		},
	];

	const [selectedOptions, setSelectedOptions] = useState([]);

	const handleCheckboxChange = (event, option) => {
		const currentIndex = selectedOptions.indexOf(option.upsellOption);
		const newSelectedOptions = [...selectedOptions];

		if (currentIndex === -1) {
			newSelectedOptions.push(option.upsellOption);
		} else {
			newSelectedOptions.splice(currentIndex, 1);
		}

		setSelectedOptions(newSelectedOptions);
	};

	const handleCloseClick = () => {
		onClose();
	};

	return (
		<Dialog
			scroll={"paper"}
			fullScreen={fullScreen}
			fullWidth={true}
			//maxWidth={"sm"}
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
			keepMounted
			classes={{
				paper: classes.dialogPaper,
				container: classes.dialogContainer2,
			}}
			BackdropProps={{
				style: {
					backgroundColor: "rgba(182, 192, 205, 0.6)",
				},
			}}
		>
			<ElevationScroll
				target={dialogContentRef}
				onElevationChange={handleElevationChange}
				{...props}
			>
				<DialogTitle
					style={{
						minHeight: 64,
						textAlign: "left",
						display: "flex",
						alignItems: "center",
					}}
					disableTypography
				>
					<Box position={"absolute"} top={8} left={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<ArrowBackOutlinedIcon />
						</IconButton>
					</Box>
					{isElevated && (
						<Box
							fontSize={20}
							fontWeight={600}
							className={classes.serviceAddTitle}
							ml={8}
							mr={8}
						>
							Additional options
						</Box>
					)}
					<Box position={"absolute"} top={8} right={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
			</ElevationScroll>
			<DialogContent
				dividers={hasOptions}
				style={{ borderTop: "unset", paddingTop: 0 }}
				ref={dialogContentRef}
			>
				<Box pb={4}>
					{hasOptions && (
						<div>
							<Box
								display={"flex"}
								justifyContent={"space-between"}
								alignItems={"center"}
								mb={2}
							>
								<div>
									<Box fontSize={28} fontWeight={600} mb={1}>
										Additional options
									</Box>
									<Box color={"grey.600"} fontSize={15}>
										Optional
									</Box>
								</div>

								{/* <Box fontSize={14} fontWeight={600} color={"#c31c3b"}>
									2 spots left!
								</Box> */}
							</Box>
							<UpsellsList />
						</div>
					)}
				</Box>
			</DialogContent>
			<DialogActions style={{ padding: "20px 24px 24px 24px" }}>
				<Box display={"flex"} width={"100%"} flexDirection={"column"}>
					{selectedOptions.length > 0 ? (
						<Button
							fullWidth
							onClick={handleCloseClick}
							size={"large"}
							variant="contained"
							color="primary"
							disableElevation
						>
							Add to booking
						</Button>
					) : (
						<Button
							fullWidth
							onClick={handleCloseClick}
							size={"large"}
							variant="contained"
							color="primary"
							disableElevation
						>
							Skip
						</Button>
					)}
				</Box>
			</DialogActions>
		</Dialog>
	);
};

ServiceAddUpsells.propTypes = {};
export default ServiceAddUpsells;
